/**
 * @fileoverview Entity Picker folder list presentation component
 */
goog.declareModuleId('yext.ui.components.entitypicker.FolderList');

import {FolderItem} from '/ui/components/entitypicker/itemlist/folderitem';
import {yext} from '/ui/lib/msg';


export class FolderList extends React.Component {
  constructor(props) {
    super(props);

    this.noResultsMsg = yext.msg('There were no folders found.');
    this.folderIsVisible = this.folderIsVisible.bind(this);
    this.getFolderRenderer = this.getFolderRenderer.bind(this);
    this.parentToDescendants = {};
    this.updateDescendantLists();
  }

  componentDidUpdate() {
    // Don't update descendant lists when only viewing a subset of folders.
    // TODO(amullings): This is basically a hack that depends on the fact that
    // we return all folders on the account when searching with an empty query.
    // If we start limiting the number of folders returned, we'll need a better
    // solution to this.
    const descendantMapSize = Object.keys(this.parentToDescendants).length;
    if (this.props.folders.length > descendantMapSize) {
      this.updateDescendantLists();
    }
  }

  updateDescendantLists() {
    const parentToChildren = buildParentMap(this.props.folders);
    this.parentToDescendants = buildDescendantLists(
      this.props.folders,
      parentToChildren);
  }

  folderIsVisible(folder) {
    return !this.props.hiddenFolders.some(f => f.id === folder.id);
  }

  getFolderRenderer(folders) {
    const parentToChildren = buildParentMap(folders);

    // TODO: Figure out if this is a bug
    /** @suppress {unusedLocalVariables} */
    const parentToDescendants = buildDescendantLists(folders, parentToChildren);
    const renderer = folder => (
      <FolderItem
        folder={folder}
        key={folder.id}
        onClick={() => {
          const descendants = this.parentToDescendants[folder.id];
          this.props.folderClickHandler(folder, descendants);
        }}
      >
        {parentToChildren[folder.id].filter(this.folderIsVisible).map(renderer)}
      </FolderItem>
    );

    return renderer;
  }

  render() {
    const includedFolderIds = this.props.folders.map(f => f.id);
    const topLevelFolders = this.props.folders.filter(
      f => !includedFolderIds.includes(f.parentId) && this.folderIsVisible(f));
    const renderer = this.getFolderRenderer(this.props.folders);

    return (
      <ul className="uep-folder-list">
        {(this.props.folders.length > 0 && !this.props.allSelected)
          ? topLevelFolders.map(renderer)
          : <span className="uep-no-results">{this.noResultsMsg}</span>}
      </ul>
    );
  }
}

function buildParentMap(folders) {
  const parentToChildren = {};

  folders.forEach(f => {
    parentToChildren[f.id] = [];
    parentToChildren[f.parentId] = [];
  });
  folders.forEach(f => parentToChildren[f.parentId].push(f));

  return parentToChildren;
}

// NOTE(amullings): This will only return descendants for which the whole chain
// is available i.e. if the list of folders given is incomplete, then there may
// be descendants missing from the lists.
function buildDescendantLists(folders, parentToChildren) {
  const parentToDescendantIds = {};

  const getDescendants = id =>
    parentToChildren[id]
      .map(f => [f.id, ...getDescendants(f.id)])
      .reduce((arr1, arr2) => arr1.concat(arr2), []);

  folders.forEach(f => {
    parentToDescendantIds[f.id] = getDescendants(f.id);
  });

  return parentToDescendantIds;
}
